export { default } from './component-renderer.view';
